import bannerIcon from "gamfi/assets/images/icons/icon1.png";
import BannerStyleWrapper from "gamfi/sections/Banner/v1/Banner.style";

const Banner = () => {
  return (
    <>
      <BannerStyleWrapper>
        <div className="container">
          <div className="banner-content text-center">
            <img src={bannerIcon} className="banner-icon" alt="banner icon" />
            <h1 className="banner-title">Metaverse Energy Airdrop</h1>
            <div className="description">
              The next generation gaming ecosystem for IGOs and NFT
            </div>
          </div>
        </div>
      </BannerStyleWrapper>
    </>
  );
};

export default Banner;
